export default "__VITE_ASSET__4croOzeh__"